import * as UpChunk from '@mux/upchunk';
import $ from 'jquery';
import auth from '../auth';

const upload = ({ file, url, chunkSize = 5120, onProgress }) => {
  const upload = UpChunk.createUpload({
    endpoint: url,
    file: file,
    chunkSize: chunkSize,
  });
  upload.on('progress', (progress) => {
    onProgress && onProgress(progress.detail);
  });
  return upload;
};

const findExerciseInLibrary = ({ exerciseName }) => {
  return new Promise((resolve, reject) => {
    if (!exerciseName) {
      return { data: [] };
    }
    $.ajax({
      url: `${
        import.meta.env.VITE_MUX_API_URL
      }/exercise-library?exerciseName=${exerciseName}`,
      type: 'GET',
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', auth.getToken());
      },
      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
};

const generateMuxSignedUrl = ({
  influencerId,
  fileSize,
  title,
  thumbnailPosition,
  bucketName,
}) => {
  return new Promise((resolve, reject) => {
    const data = {
      influencerId: parseInt(influencerId),
      chosenThumbnail: parseInt(thumbnailPosition),
      fileSize,
      title,
      bucketName,
    };
    $.ajax({
      url: `${import.meta.env.VITE_MUX_API_URL}/signed-url`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', auth.getToken());
      },
      success(response) {
        return resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        return reject(e);
      },
    });
  });
};

const listAllVideoFiles = ({ influencerId }) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${
        import.meta.env.VITE_MUX_API_URL
      }/library?influencerId=${influencerId}`,
      type: 'GET',
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', auth.getToken());
      },
      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
};

const fetchVideo = async (videoId) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${import.meta.env.VITE_MUX_API_URL}/video/${videoId}`,
      type: 'GET',
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', auth.getToken());
      },
      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
};

const generateStreamKey = ({ influencerId }) => {
  const data = {
    influencerId,
  };
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${import.meta.env.VITE_MUX_API_URL}/live-stream`,
      type: 'POST',
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', auth.getToken());
      },
      success(response) {
        resolve(response);
      },
      data: JSON.stringify(data),
      error(e) {
        if (e.status === 401) {
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
};

const deleteVideo = ({ videoId }) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${import.meta.env.VITE_MUX_API_URL}/video/${videoId}`,
      type: 'DELETE',
      beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', auth.getToken());
      },
      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
};

function formatFileSizeInBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

function formatDuration(duration) {
  if (!duration) {
    return '-';
  }
  return new Date(duration * 1000).toISOString().substr(11, 8);
}

export default {
  upload,
  generateMuxSignedUrl,
  listAllVideoFiles,
  formatFileSizeInBytes,
  deleteVideo,
  formatDuration,
  generateStreamKey,
  findExerciseInLibrary,
  fetchVideo,
};

export {
  upload,
  generateMuxSignedUrl,
  listAllVideoFiles,
  formatFileSizeInBytes,
  deleteVideo,
  formatDuration,
  generateStreamKey,
  findExerciseInLibrary,
  fetchVideo,
};
